module.exports = __webpack_public_path__ + "static/media/dz.3a562b67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/dz.png
// module id = 1836
// module chunks = 0